module.exports = __webpack_public_path__ + "img/IM.22b2c2e5.svg";